// Constants for change types
export const CHANGE_TYPES = {
  DEMOGRAPHICS: 'demographics',
  OBJECT_MODIFICATION: 'object_modification',
  STATUS_CHANGE: 'status_change',
  MONETARY: 'monetary',
  DATE: 'date',
  BOOLEAN: 'boolean',
  ARRAY: 'array',
  SIMPLE: 'simple'
}

// Constants for entity types
export const ENTITY_TYPES = {
  ADVERTISER: 'ADVERTISER',
  CAMPAIGN: 'CAMPAIGN',
  CAMPAIGN_PACKAGE: 'CAMPAIGN_PACKAGE',
  CAMPAIGN_LINE: 'CAMPAIGN_LINE',
  CREATIVE: 'CREATIVE',
  CUSTOM_TARGETING: 'CUSTOM_TARGETING',
  USER: 'USER'
}

// Fields to ignore in change display
export const IGNORED_FIELDS = ['updated_at', 'created_at', 'id', 'uuid']

// Important fields for object comparison
export const IMPORTANT_FIELDS = ['name', 'title', 'status', 'amount', 'budget', 'type']

// Field name translations
export const FIELD_NAMES = {
  name: 'Nome',
  title: 'Título',
  status: 'Status',
  budget: 'Orçamento',
  start_date: 'Data de Início',
  end_date: 'Data de Fim',
  description: 'Descrição',
  type: 'Tipo',
  active: 'Ativo',
  enabled: 'Habilitado',
  priority: 'Prioridade',
  weight: 'Peso',
  url: 'URL',
  target_audience: 'Público Alvo',
  objective: 'Objetivo',
  campaign_type: 'Tipo de Campanha',
  campaign_package: 'Grupo de Campanha',
  creative_format: 'Formato do Criativo',
  bid_strategy: 'Estratégia de Lance',
  frequency_cap: 'Limite de Frequência',
  targeting: 'Segmentação',
  geo_targeting: 'Segmentação Geográfica',
  device_targeting: 'Segmentação por Dispositivo',
  age_targeting: 'Segmentação por Idade',
  gender_targeting: 'Segmentação por Gênero',
  keyword_targeting: 'Segmentação por Palavra-chave',
  placement_targeting: 'Segmentação por Posicionamento',
  category_targeting: 'Segmentação por Categoria',
  custom_targeting: 'Segmentação Personalizada',
  daily_budget: 'Orçamento Diário',
  total_budget: 'Orçamento Total',
  bid_amount: 'Valor do Lance',
  max_bid: 'Lance Máximo',
  min_bid: 'Lance Mínimo',
  demographics: 'Demografia'
}

// Gender translations
export const GENDER_LABELS = {
  MALE: 'Masculino',
  FEMALE: 'Feminino',
  UNKNOWN: 'Não especificado',
  OTHER: 'Outro'
}

// Action verbs
export const ACTION_VERBS = {
  CREATE: 'Criou',
  UPDATE: 'Atualizou',
  DELETE: 'Excluiu',
  DESTROY: 'Excluiu',
  ACTIVATE: 'Ativou',
  PAUSE: 'Pausou',
  IMPERSONATE: 'Usou o impersonate',
  REPLICATE: 'Replicou',
  DOWNLOAD: 'Baixou NFSe',
  CANCEL: 'Cancelou',
  IMPORT: 'Importou',
  APPROVE: 'Aprovou',
  ISSUE: 'Emitiu'
}
